<agu-item-card
    [Recommended]="Recommended"
    [IsNew]="Grant.isNew"
    [Saved]="Grant.itemState.saved"
    [Pinned]="Grant.itemState.pinned"
    [ShowPin]="ShowPin"
    [ShowDismiss]="ShowDismiss"
    [ShowPinnedChip]="true"
    [Closed]="ClosingIsClosed"
    SaveLabel="Save grant"
    (SaveToggled)="Save.emit($event)"
    (PinToggled)="Pin.emit($event)"
    (Dismissed)="Dismiss.emit()"
    (RowActivated)="Open.emit()"
>
    @if (Grant.funderType) {
        <!-- On a phone the type moves into the funder line when there is one (`.mftype`, P/Member_Hub.html:689-692, 987-993). -->
        <span chips class="agu-card__chip" [class.ra-grant-card__type-chip--inlined]="!!Grant.grantor" [attr.data-tone]="FunderTone">{{ Grant.funderType }}</span>
    }
    @if (DueChip) {
        <span chips class="ra-grant-card__due">{{ DueChip }}</span>
    }

    <!-- h2 on the Saved board (P/for-you.html:947), h3 in the finders (P/grant-finder.html:378). -->
    @if (TitleLevel === 2) {
        <h2 title class="ra-grant-card__title">
            <button type="button" class="agu-card__title-btn" (click)="Open.emit()">{{ Grant.title }}</button>
        </h2>
    } @else {
        <h3 title class="ra-grant-card__title">
            <button type="button" class="agu-card__title-btn" (click)="Open.emit()">{{ Grant.title }}</button>
        </h3>
    }

    @if (Grant.grantor) {
        <p sub class="ra-grant-card__funder">@if (Grant.funderType) {<span class="ra-grant-card__ftype">{{ Grant.funderType }}</span>}{{ Grant.grantor }}</p>
    }

    <ul facts class="ra-grant-card__facts">
        <li>
            <span class="ra-grant-card__k">Award</span>
            <span class="ra-grant-card__v ra-grant-card__v--amt">{{ AwardLine }}</span>
        </li>
        <li>
            <span class="ra-grant-card__k">Closes</span>
            <span class="ra-grant-card__v">
                {{ ClosingDate }}@if (ClosingSuffix) {<span> · </span><span
                    [class.ra-grant-card__soon]="ClosingSoon"
                    [class.ra-grant-card__closed]="ClosingIsClosed"
                >{{ ClosingSuffix }}</span>}
            </span>
        </li>
        <li>
            <span class="ra-grant-card__k">Eligible</span>
            <span class="ra-grant-card__v">{{ EligibleLine }}</span>
        </li>
        @if (LocationLine) {
            <li>
                <span class="ra-grant-card__k">Location</span>
                <span class="ra-grant-card__v">{{ LocationLine }}</span>
            </li>
        }
    </ul>

    <button type="button" ctas class="agu-card__cta agu-card__cta--quiet" (click)="Open.emit()">View details</button>
    @if (Grant.url) {
        <a ctas class="agu-card__cta agu-card__cta--primary" [href]="Grant.url" target="_blank" rel="noopener">Apply now <span aria-hidden="true">↗</span></a>
    } @else {
        <button type="button" ctas class="agu-card__cta agu-card__cta--primary" (click)="Open.emit()">Apply now</button>
    }
</agu-item-card>
